import { render, staticRenderFns } from "./account.vue?vue&type=template&id=515515f7&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515515f7')) {
      api.createRecord('515515f7', component.options)
    } else {
      api.reload('515515f7', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=515515f7&", function () {
      api.rerender('515515f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account/account.vue"
export default component.exports